(function() { window.GUID_e0ee4664_2dc1_4a81_99a2_980bb7bd64e9 = { getGuid: function() { return "e0ee4664-2dc1-4a81-99a2-980bb7bd64e9"; } }; })();
var CS;
(function (CS) {
    var Shared;
    (function (Shared) {
        class FriendControls {
            constructor() { }
            Dispose(callback) {
                let me = this;
                CS.DOM.$body.off("click.friend-toolbar-button", ".friend-toolbar-button", function (e) {
                    me.onButtonClick(e, callback);
                });
            }
            BindEvents(callback) {
                let me = this;
                CS.DOM.$body.offon("click.friend-toolbar-button", ".friend-toolbar-button", function (e) {
                    me.onButtonClick(e, callback);
                });
            }
            onButtonClick(e, callback) {
                let me = this;
                let $button = $(e.currentTarget);
                const fromModal = $button.is(`[id*="from-modal"]`);
                const { action, url, personaId, isFriend } = $button.data().html;
                console.log(action);
                if (action == "notifications") {
                    CS.Controls.Popup.ShowAjaxModal(url, null, ({ popup, isPopup }) => {
                        if (!isPopup) {
                            return;
                        }
                        // Popup loaded
                        CS.Controls.CheckBox.Events.CheckboxValueChanged({
                            selector: popup.$Control,
                            childSelector: ".notif-checkbox-global",
                            callback: (checkbox, e) => {
                                //const $toolbarButton = $(`#button-friend-follow-${personaId}`);
                                //CS.Ajax.Post($toolbarButton.data().html.url, null, function (response) {
                                //    me.replaceToolbarContent($toolbarButton.closest('.friend-toolbar'), response, () => {
                                //        popup.Refresh();
                                //    });
                                //});
                                let gettoolbarurl = $button.data().html.gettoolbarurl;
                                CS.Ajax.Get(gettoolbarurl, null, function (response) {
                                    me.replaceToolbarContent($button.closest(".friend-toolbar"), response, () => {
                                        CS.Lag(personaId, 250, () => {
                                            popup.Refresh();
                                        });
                                    });
                                });
                            },
                        });
                    }, ({ popup }) => {
                        // Popup closed
                        console.log("Notificatinos popup closed");
                        let gettoolbarurl = $button.data().html.gettoolbarurl;
                        CS.Ajax.Get(gettoolbarurl, null, function (response) {
                            const $toolbarButton = $(`#button-friend-follow-${personaId}`);
                            me.replaceToolbarContent($toolbarButton.closest(".friend-toolbar"), response);
                        });
                    }, true);
                }
                else if (action == "delete") {
                    let { areyousureurl } = $button.data().html;
                    CS.Controls.Popup.ShowAjaxModal(areyousureurl, null, null, function ({ popup }) {
                        if (popup.Proceed) {
                            CS.Ajax.Post(url, null, function (response) {
                                let $listItem = $button.closest(".list-item");
                                $listItem.slideUp(150, () => {
                                    $listItem.remove();
                                });
                            });
                        }
                    });
                }
                else {
                    CS.Ajax.Post(url, null, function (response) {
                        const $toolbarButton = $(`#button-friend-follow-${personaId}`);
                        if (action == "follow" && fromModal) {
                            const $popup = $button.closest(".popup.control-cs");
                            if ($toolbarButton.length) {
                                const $toolbar = $toolbarButton.closest(".friend-toolbar");
                                me.replaceToolbarContent($toolbar, response);
                            }
                            if ($popup.length) {
                                const popup = CS.Controls.GetInstance(CS.Controls.Popup, $popup, true);
                                if (popup != null) {
                                    popup.Refresh();
                                }
                            }
                            if (callback) {
                                callback.call(this, !isFriend);
                            }
                        }
                        else {
                            if ($toolbarButton.length) {
                                me.replaceToolbarContent($toolbarButton.closest(".friend-toolbar"), response);
                            }
                            else {
                                me.replaceToolbarContent($button.closest(".friend-toolbar"), response);
                            }
                        }
                    });
                }
            }
            replaceToolbarContent($toolbar, response, callback) {
                $toolbar.replaceWith(response);
                if (callback) {
                    callback.call(this);
                }
            }
        }
        Shared.FriendControls = FriendControls;
    })(Shared = CS.Shared || (CS.Shared = {}));
})(CS || (CS = {}));

//# sourceMappingURL=friend.pre.js.map
